export enum API_ERRORS {
  internalServerError = 500,
  invalidId = 501,
  duplicatedValue = 502,
  fieldsRequired = 503,
  notFound = 504,
  userNotFound = 505,
  companyNotFound = 506,
  ticketNotFound = 507,
  companyBlocked = 508,
  personNotFound = 509,
  vehicleNotFound = 510,
  roNotFound = 511,
  checklistNotFound = 512,
  invalidCompany = 513,
  invalidPermissions = 514,
  invalidState = 515,
  invalidValue = 516,
  invalidDateFormat = 517,
  invalidBreakdowns = 518,
  invalidParameters = 519,
  biddingNotFound = 520,
  processNotFound = 521,
  orderNotFound = 522,
  clientNotFound = 523,
  operationNotFound = 524,
  roTypeNotFound = 525,
  roIsNotClosed = 526,
  numberAndSerieAlreadyUsed = 527,
  missignNumberOrAndSerieForInvoiceType = 528,
  cannotIssueNfeForUnknowClient = 529,
  nfceWithLiquidValueHigherThan15000ForUnkownClient = 530,
  companyNotFoundInMkgoInvoiceDb = 531,
  cannotIssueNfseForUnknowClient = 532,
  invoiceNotFound = 533,
  qVolIsRequired = 534,
  diagwebIntegrationFailed = 535,
  companyNotIntegratedWithDiagweb = 536,
  diagwebMaintenanceLimitExceeded = 537,
  missingPlateOrKm = 538,
  diagwebInvalidPlate = 539,
  diagwebInvalidKm = 540,
  flatInvoiceNotFound = 541,
  ruralFarmRequired = 543,
  osGroupInvalidPayload = 544,
  invoiceRefundCannotBeDevolutioned = 545,
  // integrate-migrate refund errors (549-551) collide with the OS type codes: see REFUND_API_ERRORS
  osTypeInactive = 549,
  osTypeReferenceNotFound = 550,
  lowEffectRolledBack = 551,
  lowOutcomeUnknown = 552,
  cardGroupConfirmationRequired = 553,
  cashierClosed = 554,
  lowCancelReverted = 555,
  titleHasActiveLows = 556,
  titleClientLocked = 557,
  titleMoneyLocked = 558,
  invalidTitleTransition = 559,
  insufficientAdvanceBalance = 560,
  operationIdRequired = 561,
  cashierStateConflict = 562,
  advanceAlreadyUsed = 563,
  receiveAlreadyCanceled = 564,
  insufficientCashierBalance = 565,
  titleReceivedMustBeEmpty = 566,
  invalidStatusTitle = 567,
  invalidSupplierClient = 568,
  expenseAllocationSumMismatch = 569,
  expenseAllocationNotPayable = 570,
  invalidExpenseType = 571,
  invalidExpenseTypeValue = 572,
  invalidExpenseAllocation = 573,
  titleOriginConflict = 574,
  invalidPaymentCondition = 575,
  invalidTitleBank = 576,
  titleCanceled = 581,
  personSearchTimeout = 579,
  personSearchTermTooShort = 580,
  whatsappNotConnected = 577,
  whatsappDailyLimitReached = 578,
  clientHasOverdueTitles = 582,
}
